let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3HAPT")).then(() => parcelRequire('7BQ4p'));